export enum UserLegalType {
  PERSONAL = 'Personal',
  COMPANY = 'Company',
}
